import { TestimonialItem } from '@/components/pages/TestimonialsPage/Testimonials/TestimonialItem/TestimonialItem';
import { ITestimonialItem } from '@/api/testimonials/testimonials.types';
import s from './FullTestimonialPopup.module.scss';

export const FullTestimonialPopup = ({ testimonial }: { testimonial: ITestimonialItem }) => {
  return (
    <div className={s.fullTestimonial}>
      <h3>Отзыв</h3>
      <TestimonialItem testimonial={testimonial} className={s.fullTestimonial__item} />
    </div>
  );
};